<template>
  <div class="scanner">
    <h3
      v-if="pageTitle"
      class="mb-3"
    >
      {{ pageTitle }}
    </h3>
    <form
      class="d-flex mb-5"
      @submit.prevent="onInput(result)"
    >
      <v-text-field
        v-model="result"
        autofocus
        outlined
        hide-details
        :placeholder="title"
      />
      <v-btn
        type="submit"
        x-large
        height="56"
        class="d-none"
        :disabled="!result"
      >
        Ввод
      </v-btn>
    </form>
    <div class="d-flex">
      <v-btn
        type="submit"
        x-large
        append
        class="flex-grow-1 mr-2"
        @click="startScanning"
      >
        Сканировать QR
        <v-img
          max-width="34"
          class="ml-auto"
          src="@/assets/images/icon-qr.svg"
        />
      </v-btn>
      <v-btn
        x-large
        class="torch-btn"
        :active="torch"
        :elevation="torch ? '0' : '2'"
        @click="torch = !torch"
      >
        <v-icon
          :color="torch ? 'primary' : 'black'"
          size="34"
        >
          {{ torchIcon }}
        </v-icon>
      </v-btn>
    </div>

    <transition name="fade">
      <qrcode-reader
        v-model="isScannerShown"
        :torch="torch"
        :paused="paused"
        @decode="onDecode"
      />
    </transition>
  </div>
</template>

<script>
import QRCodeReader from '@/components/QRCodeReader.vue';

export default {
  name: 'Scanner',
  components: {
    'qrcode-reader': QRCodeReader,
  },
  props: {
    pageTitle: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    paused: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    result: '',
    isScannerShown: false,
    torch: false,
  }),
  computed: {
    torchIcon() {
      return `mdi-flashlight${this.torch ? '' : '-off'}`;
    },
  },
  methods: {
    startScanning() {
      this.isScannerShown = true;
    },
    stopScanning() {
      this.isScannerShown = false;
      this.result = '';
    },
    onInput(result) {
      this.$emit('input', result.trim().toUpperCase());
    },
    onDecode(result) {
      this.onInput(result);
      this.stopScanning();
    },
  },
};
</script>

<style lang="scss" scoped>
.scanner {
  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;
  padding: 20px;
  background: white;
}

.torch-btn {
  min-width: 52px !important;
}
</style>
